(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-board-editor"]) return;
  try {
    
if (!customElements.get('ss-board-video')) {
  customElements.define('ss-board-video', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let userPaused = false;
      video.muted = true;
      button.hidden = false;
      const play = () => video.play().catch(() => {});
      const sync = () => button.setAttribute('aria-pressed', String(!video.paused));
      video.addEventListener('play', sync, { signal });
      video.addEventListener('pause', sync, { signal });
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      }, { signal });
      motion.addEventListener('change', () => {
        if (motion.matches) video.pause();
        else if (visible && !userPaused) play();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !motion.matches && !userPaused) play();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) video.pause();
        else if (!motion.matches && !userPaused && !document.hidden) play();
      }, { threshold: 0.15 });
      this.observer.observe(video);
      sync();
    }
    disconnectedCallback() {
      this.events.abort();
      this.observer.disconnect();
      this.querySelector('video').pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-frameguards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-frameguard-video')) {
  customElements.define('ss-frameguard-video', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let userPaused = false;
      video.muted = true;
      button.hidden = false;
      const play = () => video.play().catch(() => {});
      const sync = () => button.setAttribute('aria-pressed', String(!video.paused));
      video.addEventListener('play', sync, { signal });
      video.addEventListener('pause', sync, { signal });
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      }, { signal });
      motion.addEventListener('change', () => {
        if (motion.matches) video.pause();
        else if (visible && !userPaused) play();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !motion.matches && !userPaused) play();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) video.pause();
        else if (!motion.matches && !userPaused && !document.hidden) play();
      }, { threshold: 0.15 });
      this.observer.observe(video);
      sync();
    }
    disconnectedCallback() {
      this.events.abort();
      this.observer.disconnect();
      this.querySelector('video').pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-inquiry-jotform"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized || !/^\d{10,20}$/.test(root.dataset.formId || '')) return;
    const find = selector => root.querySelector(selector);
    const external = find('[data-external]');
    const host = find('[data-frame-host]');
    const trigger = find('[data-load-trigger]');
    if (!external || !host || !trigger) return;
    let frame = null;
    let observer = null;
    let loadTimer = null;
    root.dataset.initialized = 'true';
    const base = new URL(external.href);
    if (base.origin !== 'https://form.jotform.com') return;
    const shopOrigin = new URL(base.searchParams.get('sourcePage')).origin;
    const label = key => find('[data-label-' + key + ']').textContent;
    let design = null;
    let packageId = '';
    let openedSignature = null;
    let initialDesign = null;
    const signature = () => JSON.stringify([design?.productId || '', design?.variantId || '', packageId]);
    function prefilledURL() {
      const url = new URL(base);
      // Native unique names read from form 262575985600062; values contain public context only.
      if (design) {
        url.searchParams.set('designInspiration', design.name + ' — ' + design.url);
        url.searchParams.set('sourceDesignName', design.name);
        url.searchParams.set('sourceProductId', design.productId);
        url.searchParams.set('sourceVariantId', design.variantId);
        url.searchParams.set('sourceProductUrl', design.url);
      }
      if (packageId) {
        url.searchParams.set('packageContext', packageId);
        if (packageId === 'adventure_plus') {
          url.searchParams.set('q15_textarea13', label('package') + ' ' + label(packageId));
        }
        url.searchParams.set('packagePreference', {essential: 'Essential', performance: 'Performance', showstopper: 'Showstopper', adventure_plus: 'Anderes Fahrzeug'}[packageId]);
      }
      if (packageId === 'adventure_plus') url.search = url.search.replace(/\+/g, '%20');
      return url;
    }
    function openForm() {
      if (frame) return; // Never navigate or replace an existing form, including on later selections.
      observer?.disconnect();
      const url = prefilledURL();
      frame = document.createElement('iframe');
      frame.id = 'JotFormIFrame-' + root.dataset.formId + '-' + root.dataset.sectionId;
      frame.title = label('title');
      frame.referrerPolicy = 'no-referrer';
      frame.loading = 'eager';
      frame.setAttribute('scrolling', 'yes');
      frame.src = url.href;
      openedSignature = signature();
      initialDesign = design;
      external.href = url.href;
      host.hidden = false;
      host.setAttribute('aria-busy', 'true');
      find('[data-load-state]').hidden = false;
      loadTimer = window.setTimeout(showLoadProblem, 15000);
      frame.addEventListener('error', showLoadProblem);
      host.appendChild(frame);
      find('[data-before-open]').hidden = true;
      find('[data-after-open]').hidden = false;
      updateSelection();
    }
    function showLoadProblem() {
      find('[data-load-state]').hidden = true;
      find('[data-load-error]').hidden = false;
      host.setAttribute('aria-busy', 'false');
    }
    function formReady() {
      window.clearTimeout(loadTimer);
      find('[data-load-state]').hidden = true;
      find('[data-load-error]').hidden = true;
      host.setAttribute('aria-busy', 'false');
    }
    function updateSelection() {
      find('[data-selection]').hidden = !design && !packageId;
      find('[data-design-card]').hidden = !design;
      find('[data-package-row]').hidden = !packageId;
      if (design) {
        find('[data-design-name]').textContent = design.name;
        find('[data-design-link]').href = design.url;
        const img = find('[data-design-image]');
        img.hidden = !design.image;
        if (design.image) img.src = design.image;
        else img.removeAttribute('src');
      }
      find('[data-package-name]').textContent = packageId ? label(packageId) : '';
      const changedAfterOpen = frame && signature() !== openedSignature;
      find('[data-manual]').hidden = !changedAfterOpen;
      find('[data-initial-selection]').hidden = !frame || !!changedAfterOpen || (!design && !packageId);
      const reference = [];
      if (!design && initialDesign) reference.push(label('remove'));
      if (design) reference.push(label('design') + ': ' + design.name + '\n' + design.url);
      if (packageId) reference.push(label('package') + ' ' + label(packageId));
      find('[data-reference]').value = reference.join('\n\n');
      find('[data-copy-status]').textContent = '';
    }
    function choose(event) {
      if (!root.isConnected) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href="#ss-anfrage"]');
      if (!link) return;
      if (link.dataset.mxDesign && link.dataset.mxDesignUrl) {
        try {
          const url = new URL(link.dataset.mxDesignUrl);
          if (url.origin !== shopOrigin || !url.pathname.includes('/products/') || !/^\d+$/.test(link.dataset.mxProductId || '') || !/^\d+$/.test(link.dataset.mxVariantId || '')) return;
          const img = link.closest('.mx-model__card')?.querySelector('.mx-model__product-image img');
          const imageUrl = img ? new URL(img.currentSrc || img.src, location.origin) : null;
          design = {name: link.dataset.mxDesign, url: url.href, productId: link.dataset.mxProductId, variantId: link.dataset.mxVariantId, image: imageUrl?.protocol === 'https:' ? imageUrl.href : ''};
        } catch (_) { return; }
      }
      if (['essential', 'performance', 'showstopper', 'adventure_plus'].includes(link.dataset.mxPackage)) packageId = link.dataset.mxPackage;
      updateSelection();
      openForm();
    }
    find('[data-remove-design]').addEventListener('click', () => { design = null; updateSelection(); });
    find('[data-copy]').addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(find('[data-reference]').value);
        find('[data-copy-status]').textContent = label('copied');
      } catch (_) {
        find('[data-reference]').focus();
        find('[data-reference]').select();
        find('[data-copy-status]').textContent = label('copy-failed');
      }
    });
    function resize(event) {
      if (!frame || event.source !== frame.contentWindow || event.origin !== base.origin || typeof event.data !== 'string') return;
      const match = /^setHeight:(\d+)(?::.*)?$/.exec(event.data);
      if (!match) return;
      const height = Number(match[1]);
      if (height >= 400 && height <= 12000) {
        frame.style.height = height + 'px';
        formReady();
      }
    }
    function hashChange() {
      if (location.hash === '#ss-anfrage') openForm();
    }
    function unload(event) {
      if (event.detail?.sectionId !== root.dataset.sectionId) return;
      observer?.disconnect();
      window.clearTimeout(loadTimer);
      document.removeEventListener('click', choose);
      window.removeEventListener('message', resize);
      window.removeEventListener('hashchange', hashChange);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('click', choose);
    window.addEventListener('message', resize);
    window.addEventListener('hashchange', hashChange);
    document.addEventListener('shopify:section:unload', unload);
    if (location.hash === '#ss-anfrage') openForm();
    else if ('IntersectionObserver' in window) {
      const packageLinks = Array.from(document.querySelectorAll('a[href="#ss-anfrage"][data-mx-package]'));
      let nearForm = false;
      observer = new IntersectionObserver(entries => {
        const formEntry = entries.find(entry => entry.target === trigger);
        if (formEntry) nearForm = formEntry.isIntersecting;
        const choosingPackage = packageLinks.some(link => {
          const bounds = link.getBoundingClientRect();
          return bounds.width > 0 && bounds.bottom > 0 && bounds.top < window.innerHeight;
        });
        if (nearForm && !choosingPackage) openForm();
      }, {rootMargin: '0px 0px 700px 0px', threshold: 0});
      observer.observe(trigger);
      packageLinks.forEach(link => observer.observe(link));
    } else openForm();
  }
  document.querySelectorAll('[data-ss-jotform]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ss-jotform]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-kart-jotform"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    var link=root.querySelector('[data-kart-external]'),host=root.querySelector('[data-kart-frame]');
    if(!link||!host)return;
    var base=new URL(link.href),frame=null,timer=null,observer=null;
    var loading=root.querySelector('[data-kart-load]'),error=root.querySelector('[data-kart-error]');
    function load(){
      if(frame)return;
      if(observer)observer.disconnect();
      frame=document.createElement('iframe');
      frame.title=host.dataset.title;
      frame.setAttribute('referrerpolicy','no-referrer');
      frame.setAttribute('allow','fullscreen');
      frame.style.height='1100px';
      loading.hidden=false;
      frame.addEventListener('load',function(){loading.hidden=true;});
      window.addEventListener('message',function(event){
        if(event.source!==frame.contentWindow||event.origin!==base.origin)return;
        var match=typeof event.data==='string'&&event.data.match(/^setHeight:(\d+)(?::|$)/);
        if(match){var h=Number(match[1]);if(h>=400&&h<=12000){frame.style.height=h+'px';loading.hidden=true;error.hidden=true;clearTimeout(timer);}}
      });
      timer=setTimeout(function(){error.hidden=false;},16000);
      frame.src=base.href;
      host.appendChild(frame);
    }
    if('IntersectionObserver' in window){observer=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;}))load();},{rootMargin:'700px'});observer.observe(root);}else{load();}
    function hashLoad(){if(window.location.hash==='#ss-anfrage')load();}
    window.addEventListener('hashchange',hashLoad);hashLoad();
    document.addEventListener('click',function(event){var a=event.target.closest('a[href="#ss-anfrage"]');if(a)load();});
  }
  function start(){document.querySelectorAll('[data-kart-form]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-mudguards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ss-mudguard-video')) {
  customElements.define('ss-mudguard-video', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const signal = this.events.signal;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let userPaused = false;
      video.muted = true;
      button.hidden = false;
      const play = () => video.play().catch(() => {});
      const sync = () => button.setAttribute('aria-pressed', String(!video.paused));
      video.addEventListener('play', sync, { signal });
      video.addEventListener('pause', sync, { signal });
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      }, { signal });
      motion.addEventListener('change', () => {
        if (motion.matches) video.pause();
        else if (visible && !userPaused) play();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !motion.matches && !userPaused) play();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (!visible) video.pause();
        else if (!motion.matches && !userPaused && !document.hidden) play();
      }, { threshold: 0.15 });
      this.observer.observe(video);
      sync();
    }
    disconnectedCallback() {
      this.events.abort();
      this.observer.disconnect();
      this.querySelector('video').pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-mx-inquiry"]) return;
  try {
    
 (() => {
  // Native Shopify POST/CAPTCHA remains in charge. No AJAX submission or token storage.
  const recoveryKey = 'ss-yamaha-inquiry-v1';
  const successKey = 'ss-yamaha-inquiry-success';
  const recoveryLifetime = 15 * 60 * 1000;
  const recoveryFields = ['modell', 'model_id', 'modell_status', 'baujahr', 'baujahr_unsicher', 'kunststoff_form', 'kunststoff_kit_details', 'name', 'email', 'design_inspiration', 'stil', 'phone', 'instagram', 'fahrername', 'startnummer', 'kunststoff_kit_farbe', 'paket_id', 'umfang', 'finish', 'farben', 'inspiration', 'body'];
  function initialise(root) {
   const form = root.querySelector('#ss-form');
   const picker = root.querySelector('[data-yamaha-picker]');
   if (root.querySelector('.mx-inquiry__success')) {
    try { sessionStorage.removeItem(recoveryKey); sessionStorage.setItem(successKey, String(Date.now())); } catch (_) { /* Storage can be disabled. */ }
   }
   if (!form || !picker || picker.dataset.ready) return;
   // A non-personal timestamp identifies this history entry even without bfcache.
   // Preserve other apps' history state; never place field contents in history or URLs.
   let pageStarted = Date.now();
   try {
    if (!history.state || (typeof history.state === 'object' && !Array.isArray(history.state))) {
     pageStarted = Number(history.state?.ssYamahaFormOpenedAt) || pageStarted;
     history.replaceState({...history.state, ssYamahaFormOpenedAt: pageStarted}, '');
    }
   } catch (_) { /* Recovery still works if history state cannot be written. */ }
   const optional = form.querySelector('[data-mx-optional]');
   const packageField = form.querySelector('#mx-paket');
   // Preserve the established email/automation field. Never derive IDs from translated text or prices.
   // Without JS the original native select still submits the established legacy contract.
   const legacyPackages = new Map(Array.from(packageField.options, option => [option.dataset.packageId || '', option.value]));
   packageField.name = 'contact[paket_id]';
   Array.from(packageField.options).forEach(option => { option.value = option.dataset.packageId || ''; });
   const legacyPackage = document.createElement('input');
   legacyPackage.type = 'hidden'; legacyPackage.name = 'contact[paket]';
   packageField.after(legacyPackage);
   const syncPackage = () => { legacyPackage.value = legacyPackages.get(packageField.value) || ''; };
   packageField.addEventListener('change', syncPackage);
   form.addEventListener('formdata', event => { syncPackage(); event.formData.set('contact[paket]', legacyPackage.value); });
   syncPackage();
   optional.open = false;
   const input = picker.querySelector('#mx-modell');
   const nativeList = picker.querySelector('datalist');
   const modelId = form.elements['contact[model_id]'];
   const modelStatus = form.elements['contact[modell_status]'];
   const group = picker.querySelector('#mx-model-group');
   const popup = picker.querySelector('.mx-inquiry__suggestions');
   const list = picker.querySelector('[role="listbox"]');
   const resultStatus = picker.querySelector('[data-yamaha-results-status]');
   const selection = picker.querySelector('[data-yamaha-selection]');
   const noResults = picker.querySelector('.mx-inquiry__no-results');
   const uncertainValue = nativeList.querySelector('[data-model-status="uncertain"]').value;
   const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/yamaha/g, '').replace(/[^a-z0-9]/g, '');
   const catalogue = Array.from(nativeList.querySelectorAll('[data-model-id]'), option => ({
    id: option.dataset.modelId,
    label: option.value,
    family: option.dataset.family,
    familyLabel: option.dataset.familyLabel,
    terms: [option.value, ...option.dataset.aliases.split(',')].map(normalize)
   }));
   const families = new Map(catalogue.map(item => [item.family, item.familyLabel]));
   for (const [value, label] of families) group.add(new Option(label, value));
   let results = [], active = -1;
   function close() {
    popup.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
   }
   function updateSelection() {
    const text = input.value.trim();
    if (modelId.value && catalogue.find(item => item.id === modelId.value)?.label !== text) {
     modelId.value = '';
     modelStatus.value = 'free_text';
    }
    if (text !== uncertainValue && modelStatus.value === 'uncertain') modelStatus.value = 'free_text';
    if (text === uncertainValue) {
     modelStatus.value = 'uncertain';
     modelId.value = '';
    }
    selection.textContent = !text ? picker.dataset.empty : modelStatus.value === 'uncertain'
     ? picker.dataset.uncertain
     : (modelId.value ? picker.dataset.selected : picker.dataset.free).replace('__label__', text);
   }
   function render() {
    const query = normalize(input.value);
    results = catalogue.filter(item => (!group.value || item.family === group.value) && (!query || item.terms.some(term => term.includes(query))));
    results.sort((a, b) => Number(b.terms.includes(query)) - Number(a.terms.includes(query)));
    list.replaceChildren();
    results.forEach((item, index) => {
     const option = document.createElement('li');
     option.id = 'mx-yamaha-result-' + index;
     option.setAttribute('role', 'option');
     option.setAttribute('aria-selected', 'false');
     option.dataset.index = index;
     const name = document.createElement('span');
     name.textContent = item.label;
     const family = document.createElement('small');
     family.textContent = item.familyLabel;
     option.append(name, family);
     list.append(option);
    });
    active = -1;
    input.removeAttribute('aria-activedescendant');
    noResults.hidden = results.length > 0;
    resultStatus.textContent = picker.dataset.results.replace('__count__', String(results.length));
   }
   function open() {
    render();
    popup.hidden = false;
    input.setAttribute('aria-expanded', 'true');
   }
   function choose(index) {
    const item = results[index];
    if (!item) return;
    input.value = item.label;
    modelId.value = item.id;
    modelStatus.value = 'catalogue';
    clearError(input);
    updateSelection();
    close();
   }
   function clearError(field) {
    if (!field.validity.valid) return;
    field.removeAttribute('aria-invalid');
    const error = field.closest('.mx-inquiry__field')?.querySelector('.mx-inquiry__field-error');
    if (error) { error.hidden = true; error.textContent = ''; }
   }
   input.addEventListener('input', () => {
    modelId.value = '';
    modelStatus.value = 'free_text';
    updateSelection();
    open();
   });
   input.addEventListener('focus', open);
   input.addEventListener('blur', event => {
    updateSelection();
    if (!picker.contains(event.relatedTarget)) close();
   });
   input.addEventListener('keydown', event => {
    if (event.isComposing) return;
    if (event.key === 'Escape') {
     if (!popup.hidden) event.preventDefault();
     close();
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
     event.preventDefault();
     if (popup.hidden) open();
     if (!results.length) return;
     active = event.key === 'ArrowDown' ? Math.min(active + 1, results.length - 1) : active < 0 ? results.length - 1 : Math.max(active - 1, 0);
     Array.from(list.children).forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
     const option = list.children[active];
     input.setAttribute('aria-activedescendant', option.id);
     option.scrollIntoView({block: 'nearest'});
    } else if (event.key === 'Enter') {
     event.preventDefault();
     if (!popup.hidden && active >= 0) choose(active);
     else { updateSelection(); close(); }
    } else if (event.key === 'Tab') close();
   });
   list.addEventListener('pointerdown', event => {
    if (event.target.closest('[role="option"]')) event.preventDefault();
   });
   list.addEventListener('click', event => {
    const option = event.target.closest('[data-index]');
    if (option) { choose(Number(option.dataset.index)); input.focus(); close(); }
   });
   group.addEventListener('change', () => { input.focus(); open(); });
   picker.querySelector('[data-yamaha-free]').addEventListener('click', () => {
    group.value = '';
    modelId.value = '';
    modelStatus.value = 'free_text';
    input.focus();
    input.select();
    updateSelection();
    close();
   });
   picker.querySelector('[data-yamaha-unknown]').addEventListener('click', () => {
    input.value = uncertainValue;
    modelId.value = '';
    modelStatus.value = 'uncertain';
    group.value = '';
    input.focus();
    updateSelection();
    clearError(input);
    close();
   });
   picker.querySelector('[data-yamaha-use-text]').addEventListener('click', () => {
    input.focus();
    updateSelection();
    close();
   });
   noResults.addEventListener('pointerdown', event => {
    if (event.target.closest('button')) event.preventDefault();
   });
   form.addEventListener('invalid', event => {
    const field = event.target;
    const collapsed = field.closest('details');
    if (collapsed) collapsed.open = true;
    field.setAttribute('aria-invalid', 'true');
    const error = field.closest('.mx-inquiry__field')?.querySelector('.mx-inquiry__field-error');
    if (error) { error.textContent = field.dataset.error || field.validationMessage; error.hidden = false; }
   }, true);
   form.addEventListener('input', event => clearError(event.target));
   form.addEventListener('focusout', event => {
    const field = event.target;
    if (field.matches('input[type="text"], input[type="email"], input[type="url"]')) {
     field.value = field.value.trim();
     clearError(field);
    }
   });
   input.removeAttribute('list');
   input.setAttribute('role', 'combobox');
   input.setAttribute('aria-autocomplete', 'list');
   input.setAttribute('aria-controls', list.id);
   input.setAttribute('aria-expanded', 'false');
   picker.querySelector('.mx-inquiry__catalog-tools').hidden = false;
   picker.querySelector('.mx-inquiry__model-actions').hidden = false;
   picker.dataset.ready = 'true';
   updateSelection();
   const serverError = root.querySelector('.mx-inquiry__error');
   // Let native fragment navigation finish before placing focus on the returned error.
   if (serverError) {
    const focusError = () => setTimeout(() => {
     if ([document.body, form, serverError].includes(document.activeElement)) serverError.focus();
    }, 0);
    focusError();
    window.addEventListener('pageshow', focusError, {once: true});
   }
   const designField = form.elements['contact[design_inspiration]'];
   const clearDesign = root.querySelector('[data-mx-clear-design]');
   const syncDesign = () => { clearDesign.hidden = !designField.value; };
   designField.addEventListener('input', syncDesign);
   clearDesign.addEventListener('click', () => {
    designField.value = '';
    syncDesign();
    root.querySelector('[data-mx-handoff]').hidden = true;
    designField.focus();
   });
   syncDesign();
   const recovery = root.querySelector('[data-mx-recovery]');
   const recoveryEnabled = recovery.querySelector('[data-mx-recovery-enabled]');
   const recoveryStatus = recovery.querySelector('[data-mx-recovery-status]');
   let expiryTimer;
   const message = kind => { recoveryStatus.textContent = recovery.dataset[kind]; recoveryStatus.hidden = false; };
   const discard = () => {
    clearTimeout(expiryTimer);
    try { sessionStorage.removeItem(recoveryKey); } catch (_) { /* Nothing can be recovered when storage is blocked. */ }
   };
   const expireAt = time => {
    clearTimeout(expiryTimer);
    expiryTimer = setTimeout(discard, Math.max(0, time - Date.now()));
   };
   function restore() {
    try {
     const raw = sessionStorage.getItem(recoveryKey);
     if (!raw) return;
     if (raw.length > 65536) { discard(); return; }
     const saved = JSON.parse(raw);
     if (saved.version !== 1 || !Number.isFinite(saved.expiresAt) || saved.expiresAt <= Date.now() || saved.expiresAt > Date.now() + recoveryLifetime || !saved.fields) { discard(); return; }
     for (const name of recoveryFields) {
      const field = form.elements['contact[' + name + ']'];
      const value = saved.fields[name];
      if (!field) continue;
      if (field.type === 'checkbox' && typeof value === 'boolean') field.checked = value;
      else if (typeof value === 'string') field.value = value;
     }
     if (modelStatus.value === 'uncertain') input.value = uncertainValue;
     if (typeof saved.group === 'string') group.value = saved.group;
     updateSelection(); syncPackage(); syncDesign();
     optional.open = true;
     expireAt(saved.expiresAt);
     message('restored');
    } catch (_) { discard(); message('unavailable'); }
   }
   function save() {
    if (!recoveryEnabled.checked) { discard(); return true; }
    const fields = {};
    for (const name of recoveryFields) {
     const field = form.elements['contact[' + name + ']'];
     if (field) fields[name] = field.type === 'checkbox' ? field.checked : field.value;
    }
    const expiresAt = Date.now() + recoveryLifetime;
    const raw = JSON.stringify({version: 1, expiresAt, fields, group: group.value});
    try {
     // Fail visibly rather than silently truncating a user's text or storing unlimited data.
     if (raw.length > 65536) throw new Error('Recovery size limit');
     sessionStorage.setItem(recoveryKey, raw);
     expireAt(expiresAt);
     return true;
    } catch (_) { discard(); message('unavailable'); return false; }
   }
   recovery.hidden = false;
   try {
    sessionStorage.setItem(recoveryKey + '-check', '1');
    sessionStorage.removeItem(recoveryKey + '-check');
   } catch (_) { message('unavailable'); }
   restore();
   recoveryEnabled.addEventListener('change', () => { if (!recoveryEnabled.checked) { discard(); message('deleted'); } });
   recovery.querySelector('[data-mx-recovery-forget]').addEventListener('click', () => { discard(); message('deleted'); });
   form.addEventListener('submit', event => {
    updateSelection(); syncPackage();
    if (!form.checkValidity()) { event.preventDefault(); return; }
    if (!save()) { event.preventDefault(); recoveryStatus.focus(); return; }
    if (navigator.onLine === false) { event.preventDefault(); message('offline'); recoveryStatus.focus(); }
   });
   window.addEventListener('pageshow', event => {
    try {
     if (Number(sessionStorage.getItem(successKey)) >= pageStarted) {
      // Browser history may restore native input state immediately after pageshow.
      setTimeout(() => {
       form.reset(); modelId.value = ''; modelStatus.value = 'free_text';
       updateSelection(); syncPackage(); syncDesign(); optional.open = false;
       discard(); recoveryStatus.hidden = true;
       pageStarted = Date.now();
       try { if (history.state?.ssYamahaFormOpenedAt) history.replaceState({...history.state, ssYamahaFormOpenedAt: pageStarted}, ''); } catch (_) { /* No field data is involved. */ }
      }, 0);
      return;
     }
    } catch (_) { /* Native back navigation can still retain the current DOM. */ }
    if (!event.persisted) return;
    // Preserve newer bfcache entries; only inspect expiry, do not replace them with an older attempt.
    try {
     const raw = sessionStorage.getItem(recoveryKey);
     if (raw) { const saved = JSON.parse(raw); if (saved.expiresAt <= Date.now()) discard(); else expireAt(saved.expiresAt); }
    } catch (_) { discard(); }
    updateSelection(); syncPackage(); syncDesign();
   });
  }
  document.querySelectorAll('.mx-inquiry').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.mx-inquiry').forEach(initialise));
  document.addEventListener('click', event => {
   const trigger = event.target.closest('.mx-model [data-mx-package], .mx-model [data-mx-design]');
   if (!trigger) return;
   const root = document.querySelector('.mx-inquiry');
   const form = root?.querySelector('#ss-form');
   const feedback = root?.querySelector('[data-mx-handoff]');
   if (!form || !feedback) return;
   if (trigger.hasAttribute('data-mx-design')) {
    const field = form.elements['contact[design_inspiration]'];
    if (!field) return;
    field.value = trigger.dataset.mxDesign + ' — ' + trigger.dataset.mxDesignUrl;
    field.dispatchEvent(new Event('input', {bubbles: true}));
    feedback.textContent = feedback.dataset.designMessage.replace('__design__', trigger.dataset.mxDesign);
   } else {
    const field = form.elements['contact[paket_id]'];
    const option = Array.from(field?.options || []).find(option => option.value === trigger.dataset.mxPackage);
    if (!option) return;
    field.value = option.value;
    root.querySelector('[data-mx-optional]').open = true;
    field.dispatchEvent(new Event('change', {bubbles: true}));
    feedback.textContent = feedback.dataset.packageMessage.replace('__package__', option.textContent);
   }
   feedback.hidden = false;
   event.preventDefault();
   const heading = root.querySelector('#mx-inquiry-heading');
   heading.focus({preventScroll: true});
   heading.scrollIntoView({block: 'start'});
  });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-mx-p03"]) return;
  try {
    
  document.querySelectorAll('[data-mx-p03]').forEach((root) => {
    const button = root.querySelector('[data-probe="validate"]');
    const input = root.querySelector('[data-probe="model"]');
    const error = root.querySelector('[data-probe="error"]');
    button.addEventListener('click', () => {
      const invalid = input.value.trim().length === 0;
      error.hidden = !invalid;
      input.setAttribute('aria-invalid', String(invalid));
      if (invalid) input.focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
